'use strict';
const merge = require('webpack-merge');
const base = require('./base');

module.exports = merge(base, {
  sendLabel: 'SEND',
  learnMore: 'Learn More',
  welcome: 'Hi, this is NKN\'s community support team. How are you today and what can we help?',
  dataRide: {
    banner1: {
      title: 'dataRide',
      text: '<strong>dataRide</strong> is a decentralized PaaS (Platform as a Service) of fast, reliable, secure and low cost messaging and direct file transfer service for person to person, machine-human as well as machine-machine communication.'
    },
    banner2: {
      title: 'dataRide',
      subTitle: 'Use Cases',
      text: `<ul>
<li style="list-style: inside">Chat and IM</li><li style="list-style: inside">IoT communication</li><li style="list-style: inside">Direct file transfer</li><li style="list-style: inside">Live chat support</li><li style="list-style: inside">Remote control of servers</li><li style="list-style: inside">Direct security camera control</li><li style="list-style: inside">Alert or update notification</li>
</ul>`,
      icon1: 'Chat & IM',
      icon2: 'IoT Comm',
      icon3: 'Direct File Transfer',
      icon4: 'Live Chat Support',
      icon5: 'Remote Control',
      icon6: 'Security Camera',
    },
    banner3: {
      title: 'Developer Benefits',
      title1: 'Simple & Lightweight SDK',
      text1: `<ul>
<li style="list-style: inside">Just a few lines of code</li><li style="list-style: inside">Mobile and web</li><li style="list-style: inside">Multiple SDK supported: Javascript, Go, Android, iOS</li>
</ul>`,
      title2: 'Free to Try, Low Cost to Deploy',
      text2: `<ul>
<li style="list-style: inside">Eliminated needs to No need to setup and maintain your own infrastructure</li><li style="list-style: inside">Generous free trial tier for developers</li><li style="list-style: inside">Significantly loweringlower cost at scale</li>
</ul>`,
      title3: 'Free & Open Source',
      text3: `<ul>
<li style="list-style: inside">No proprietary platform lock-in</li><li style="list-style: inside">No hidden backdoors</li><li style="list-style: inside">Large community support for new features and bug fixes</li>
</ul>`,
    },
    banner4: {
      title: 'User Benefits',
      title1: 'Reliable',
      text1: `<ul>
<li style="list-style: inside">Access data remotely;anywhere at your own convenience</li><li style="list-style: inside">Face no centralized servers downtime;service is always available</li>
</ul>`,
      title2: 'Secure and Private',
      text2: `<ul>
<li style="list-style: inside">User communication is end-to-end and hop-by-hop encrypted</li><li style="list-style: inside">User data will not be stored in any centralized servers</li>
</ul>`,
      title3: 'Fast Across the Globe',
      text3: `<ul>
<li style="list-style: inside">Proven fast file transfer rate, even/including internationally</li><li style="list-style: inside">Ride on the accelerated data paths, turbo charged speed</li>
</ul>`,
    },
    banner5: {
      title: 'Apps Powered by dataRide',
      title1: 'D-Chat',
      url1: 'https://forum.nkn.org/t/introducing-d-chat-a-server-less-secure-and-private-chat-for-individuals-and-groups/1861',
      title2: 'nMobile',
      url2: 'https://forum.nkn.org/t/nmobile-pre-beta-community-testing-and-simple-guide/2012',
      title3: 'nShell',
      url3: 'https://forum.nkn.org/t/nkn-shell-nsh-a-new-kind-of-remote-shell-that-is-more-secure-and-convenient-than-ssh/1719',
      title4: 'MaoPan App',
      url4: '',
    },
    banner6: {
      title: 'Developers — Try dataRide Today!',
      text: 'dataRide is live on NKN’s globally distributed network with up to 20,000 servers worldwide. Head to dataRide Learning Center and get started building your first application for FREE using dataRide!'
    },
  },
  dataRideSupport: {
    banner1: {
      title: 'Customer Service Chat',
      subTitle: 'Powered by dataRide',
      text: 'Customer Service Chat gives websites and applications an open and easy to use embedded chat solution to help you connect with your customers in real-time.'
    },
    banner2: {
      iconText1: 'NKN Wallet',
      iconText2: 'NKN Multi-client',
      title: 'Open SDK',
      text: 'NKN offers open source SDK’s in popular languages such as <a class="link" href="https://github.com/nknorg/nkn-multiclient-js" target="_blank">Javascript</a>, <a class="link" href="https://github.com/nknorg/nkn-sdk-go" target="_blank">go</a>, and <a class="link" href="https://github.com/nknorg/nkn-sdk-android" target="_blank">android</a> to make it easy to embed NKN’s Customer Service Chat solution into your next project.'
    },
    banner3: {
      title: 'D-Chat Customer Service Chat',
      subTitle: 'Management',
      text: 'Use the <a class="link" href="https://chrome.google.com/webstore/detail/d-chat/glnmkakdjcognfgonjfcklpmjiobijii" target="_blank">D-Chat plugin on Chrome/Brave browser</a> or nMobile on android to manage your customer service teams access and respond to messages in real-time.'
    },
    banner4: {
      title: 'Vue Model Source Code',
      text: 'Need sample code to help you build your chat bubble?  Check out our own <a class="link" href="https://github.com/iheron/vue-nkn-chat" target="_blank">vue model source code</a>.'
    },
    step1: {
      title: 'Integrate Customer Service Chat today in 3 easy steps',
      text: `<p>Import the nkn-wallet SDK and subscribe to your private group in the format of TOPIC.PublicKey.</p>
<br>
<p style="word-break: break-all; font-size: 9px;">ex. JasonsInsurance.25ac590eaca614a0ba4c4387d8514a0b54e948d120c6ff49564e7830c9dec929</p>`
    },
    step2: {
      text: `<p>Import the nkn-multiclient SDK.</p>
<br>
<p>The multiclient will get the NKN addresses of the customer support staff for the topic you subscribed in step 1.</p>
`
    },
    step3: {
      text: `<p>Add the ability to send and receive customer support messages</p>
<br>
<p>Now you are ready to go!</p>
`
    }
  },
  nCDN: {
    banner1: {
      title: 'nCDN - A New Kind of Content Delivery Network',
      subTitle: 'A New Kind of Content Delivery Network',
      text: 'nCDN is a crowdsourced service offering accelerated performance for website, video, and rich media content.'
    },
    banner2: {
      title: 'Best of both worlds',
      text: 'Our solution combines the best of traditional and P2P CDN solutions to offer reliable, low cost content delivery at scale.'
    },
    banner3: {
      title: 'Largest shared network globally',
      text: 'nCDN is based on NKN’s proven decentralized network architecture with up to 20,000 nodes in more than 40 countries and regions globally.'
    },
    banner4: {
      title: 'Simple self service portal',
      text: 'Our self service portal makes it easy to sign up and try out how nCDN can improve the performance of your website or application.'
    },
    banner5: {
      title: 'The Right Choice',
      text: 'Our low cost shared network model together with NKN’s highly available global network makes nCDN the right choice for your content delivery needs.',
      icon1: 'Low Cost',
      icon2: 'Reliable',
      icon3: 'Global Scale',
    },
    banner6: {
      title: 'Website admins: try nCDN Beta today!',
      text: 'nCDN is currently in limited beta for selected enterprise and Small Medium Business customers. Please visit ncdn.io for a free trial and see how nCDN can help accelerate your website globally and at scale.',
      icon1: 'Website acceleration',
      icon2: 'Files cache',
      icon3: 'Download acceleration',
    },
  },
  alert: {
    title: 'Click here to swap NKN token from NEP-5 to ERC-20',
    dlTip: 'Deadline: 23:59 UTC, March 28th, 2019',
    btn: 'Got it'
  },
  chat: {
    service: 'Customer Support Service'
  },
  header: {
    langSel: 'Language',
    nav: {
      tab1: 'Developer',
      tab2: 'Miner',
      tab3: 'Partner',
      tab4: 'News',
      tab5: 'About',
      tab6: 'Solution',
      tab7: 'nCDN',
      tab8: 'dataRide',
      tab9: 'Team',
      tab10: 'Roadmap',
      tab11: 'nMobile',
      tab12: 'Blog',
      tab13: 'nMobile-pro',
    }
  },
  footer: {
    nav: {
      title: 'Navigation',
      tab1: 'Developer',
      tab2: 'Miner',
      tab3: 'Partner',
      tab4: 'News',
      tab5: 'About'
    },
    community: {
      title: 'Community',
      tab1: 'Telegram',
      tab2: 'Twitter',
      tab3: 'Reddit',
      tab4: 'Discord',
      tab5: 'Medium',
      tab6: 'YouTube',
      tab7: 'Forum'
    },
    resource: {
      title: 'Resource',
      tab1: 'Github',
      tab2: 'Introduction',
      tab3: 'Whitepaper',
      tab4: 'Logo',
      tab5: 'Dev Doc',
      tab6: 'Core tech',
    },
    subscribe: {
      title: 'Further information upon request:',
      inputph: 'Your email address',
      btn: 'subscribe',
      success: 'You had subscribed NKN news successfully!',
      notice: 'Don’t miss out on the newest NKN events!'
    },
    copyright: ' Copyright © 2017-2020 NKN | All rights reserved'
  },
  network: {
    title: {
      rank: 'RANK',
      country: 'COUNTRY',
      nodes: 'NODES'
    },
    totalCount: 'Full nodes in NKN: ',
    updatetime: 'Update time: {updatetime}'
  },
  home: {
    press: 'Press',
    header: {
      title: `NKN: Network Infra for Decentralized Internet`,
      desc:
        'NKN is a new kind of peer to peer network connectivity protocol and ecosystem powered by a novel public blockchain. It uses economic incentives to motivate Internet users to share network connections and utilize unused bandwidth. NKN\'s open, efficient, and robust networking infrastructure enables application developers to build the decentralized Internet so everyone can enjoy secure, low cost, and universally accessible connectivity.',
      btn1: 'Introduction',
      btn2: 'Try MainNet',
      news: 'NEWS: Introducing nCDN',
    },
    swiper: {
      title1: 'NKN is officially listed on Bittrex International exchange.',
      title2: 'Mainnet V0.9 Beluga Released',
      title3: 'NKN token swap:',
      title3sub: 'NEP-5 to ERC-20:',
      title4: 'NKN is listed on leading Korean exchange UPbit.',
      title5: '',
      content1sub1: 'Currently the trading pair of NKN/BTC is active:',
      content1sub2:
        '<a href="https://international.bittrex.com/Market/Index?MarketName=BTC-NKN" target="_blank">https://international.bittrex.com/Market/Index?MarketName=BTC-NKN</a>',
      content2: `Mainnet V0.9 Beluga is released on March 31, 2019. Beyond scalable networking and consensus, also featuring ledger and security enhancements. Last major release before final Mainnet v1.0 Narwhal due June.`,
      content3sub1: 'One NEP-5 NKN token swap to One ERC-20 NKN token.',
      content3sub2:
        'gate.io supports automatic swap for its customers during January 2019.',
      content3sub3:
        'Use NKN’s official web-based token swap tool, if you hold the tokens in private wallets.',
      content4sub1: 'Currently the trading pair of NKN/BTC is active: ',
      content4sub2:
        '<a href="https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN" target="_blank">https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN</a>',
      content5:
        'We are excited to announce the launch of the Web3Infra Alliance, an open developer platform for Web 3.0 applications that thrives on decentralization and the shared economy. NKN is proud to be one of the four founding members together with Bluzelle, NOIA Network, and Portal Network.'
    },
    walletAndExplorer: {
      title: 'Blockchain Wallet & Explorer',
      title1: 'Official NKN Wallet',
      subTitle1: 'Official NKN Wallet for Mainnet',
      title2: 'Official NKN Explorer',
      subTitle2: 'Official NKN Explorer for Mainnet',
      title3: 'NKN Explorer by NKNx',
      subTitle3: 'Blockchain explorer and node check',
      title4: 'nStatus',
      subTitle4: 'A simple NKN node checker',
      title5: 'Vault by NKNx',
      subTitle5: 'Desktop wallet for Windows and Mac OS',
    },
    wordmap: {
      title: 'NKN is building the world’s largest blockchain network',
      nodeDistribution:
        '<span class="full-node-title">Full nodes: </span><span class="full-node-count">{total}</span>',
      nodeByRegions:
        'Countries and regions running NKN nodes: {count} (<a href="/en/miner/" target="_self">join as miner</a>)',
      details:
        'NKN full nodes all around the world, with more nodes than Bitcoin network.'
    },
    whynkn: {
      title: 'Why',
      subtitle1:
        'Client-Server model is expensive, complex, and prone to failure & attack',
      subtitle2: 'Inefficient Network utilization results in waste of resource',
      subtitle3: 'Centralization of blockchain systems diminish trust',
      subContent1: `Today, most communications need to go through a centralized server, where it can be blocked or sabotaged, hacked into, or eavesdropped on.`,
      subContent2: `The current Internet was designed for peak traffic but most of the time these networks are underutilized, wasting unused bandwidth every second.`,
      subContent3: `Many major blockchain projects use a handful of centralized servers to carry out consensus in the name of increasing transaction speed. This sacrifices trust and security, and diminishes the technical and economic strength of a true permissionless blockchain system.`
    },
    nknAdvantage: {
      title: 'NKN advantage',
      subtitle1: 'Millions of nodes',
      subtitle2: 'Aggregated high speed',
      subtitle3: 'Low latency',
      subtitle4: 'Zero server',
      subtitle5: 'Unique and global ID',
      subtitle6: 'Extra security and privacy',
      subContent1:
        'NKN\'s novel MOCA consensus algorithm is horizontally scalable and supports an arbitrary number of consensus nodes. NKN mainnet has up to 25,000 full consensus nodes, more than Bitcoin and Ethereum.',
      subContent2:
        'Nodes and clients can utilize the aggregated speed of several routes. Adding more NKN nodes in the network can horizontally scale up throughput for the entire network.',
      subContent3:
        'Supports all applications including real-time 3D gaming, AR/VR, and IoT. Supports edge computing and optimized routing. NKN’s data transmission is off-chain and not limited by consensus speed.',
      subContent4:
        'Fully peer to peer and decentralized, no need to develop and run centralized servers. Significantly reduces complexity and costs, as well as removing the single point of failure and remove the centralized target for hacking.',
      subContent5:
        'Unique NKN addresses enable services from anywhere in the world at any time and helps people discover and search for applications and services.',
      subContent6:
        'End-to-end and hop-by-hop encryption without Public Key Infrastructure or 3rd party certificates.'
    },
    nknProduct: {
      title: 'NKN Products & Applications',
      applications: {
        title: 'dApps',
        tab1: 'Space cats, 3D multi-player action game without servers',
        tab2: 'NKN Chat, a decentralized instant messenger',
        tab3: 'Smart home IoT, secure NKN-based e2e communication solution for massive IoT devices.',
        tab4: 'D-Chat, decentralized chat based on NKN Pub/Sub messaging',
        tab5: 'Tuna, open marketplace for software services',
        tab6: 'NKN Shell (nsh), more secure and convenient than SSH',
        tab7: 'NKN d-FTP, High throughput file transfer',
      },
      wallet: {
        title: 'Wallet & Explorer',
        tab1: 'NKN Official Wallet',
        tab2: 'NKNWallet.io by community'
      },
      dashboard: {
        title: 'Dashboard',
        tab1: 'Testnet Explorer',
        tab2: 'Mainnet Explorer',
        tab3: 'New kind of Dashboard by community',
        tab4: 'Node and wallet tracker'
      },
      flagshipProducts: {
        title: 'Flagship Products',
        tab1: 'nCDN - New Kind of CDN',
        tab2: 'PubSub - Decentralized messaging & Pub/Sub'
      }
    },
    platformServices: {
      platformServicesTitle: 'NKN Platform Services',
      txtTitle: 'Communication as a Service (CaaS) Solution',
      txtDesc: 'open, dependable, fast, scalable platform services for enterprises and developers',
      nPubSub: {
        title: 'dataRide',
        desc: `<strong>dataRide</strong> is a decentralized PaaS (Platform as a Service) of fast, reliable, secure and low cost messaging and direct file transfer service for person to person, machine-human as well as machine-machine communication.
<ul>
<li style="list-style: inside"><a href="https://dataride.nkn.org/chat/" target="_blank"><strong>Chat and IM</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/iot/" target="_blank"><strong>IoT communication</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/filetransfer/" target="_blank"><strong>Direct file transfer</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/support/" target="_blank"><strong>Live chat support</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/remotecontrol/" target="_blank"><strong>Remote control of servers</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/camera/" target="_blank"><strong>Direct security camera control</strong></a></li><li style="list-style: inside"><strong>Alert or update notification</strong></li>
</ul>`
      },
      nCDN: {
        title: 'nCDN - A New Kind of Content Delivery Network',
        subtitle: 'A New Kind of Content Delivery Network',
        desc: `nCDN is a crowdsourced service offering accelerated performance for website, video, and rich media content.`
      }
    },
    communityDApp: {
      title: 'dApps based on NKN',
      nMobile: {
        title: 'nMobile',
        text: `A mobile app that combines NKN wallet, D-Chat, NKN news, mining node monitoring, and IoT communication and control.`,
        url: 'https://nmobile.nkn.org/downloads/nMobile.apk',
        betaUrl: 'https://nmobile.nkn.org/downloads/nMobile-beta.apk'
      },
      nMobilePro: {
        title: 'nMobile Pro',
        text: `A mobile app that combines NKN wallet, D-Chat, NKN news, mining node monitoring, and IoT communication and control.`,
        url: 'https://nmobile.nkn.org/downloads/nMobile-pro.apk',
      },
      dChat: {
        title: 'D-chat',
        text: 'Serverless chat for public and permissioned groups, secure and private 1-on-1 chat, as well as communicate with machines.',
        url: 'https://forum.nkn.org/t/introducing-d-chat-a-server-less-secure-and-private-chat-for-individuals-and-groups/1861'
      },
      nFtp: {
        title: 'nFTP',
        text: 'Secure and high speed file transfer service directly between any clients without any servers.',
        url: 'https://forum.nkn.org/t/nkn-d-ftp-high-throughput-file-transfer-using-nkn-client/1711'
      },
      nShell: {
        title: 'nShell',
        text: 'A new kind of remote shell that is more secure and convenient than ssh.',
        url: 'https://forum.nkn.org/t/nkn-shell-nsh-a-new-kind-of-remote-shell-that-is-more-secure-and-convenient-than-ssh/1719'
      }
    },
  },
  developer: {
    title: 'Developer Portal',
    clientIntro: {
      title: 'Introduction for Developers',
      vtitle1: 'Introduction to NKN technology',
      vtitle2: 'Introduction to NKN Client SDK'
    },
    dapp: {
      title: 'Example DApps',
      title2: 'Platform Services',
      subtitle1: 'Space Cats',
      subtitle2: 'NKN Chat',
      subtitle3: 'nknx.org',

      subtitle5: 'Smart Home IoT',
      subtitle6: 'D-Chat',
      subtitle7: 'nCDN',
      subtitle8: 'IOT',
      subtitle9: 'dataRide',
      subtitle10: 'TUNA',
      subtitle11: 'Nanopay',
      subtitle12: 'NKN Wallet',
      subtitle13: 'NKN Explorer',
      subtitle14: 'Node and wallet tracker',
      subtitle15: 'NKN Shell',
      subtitle16: 'd-FTP',
      subtitle17: 'NKN multi-client SDK',
      subtitle18: 'dataRide',

      subContent1: '3D multi-player action game without servers.',
      subContent2: 'A decentralized instant messenger built with NKN Client SDK.',
      subContent3: 'Community built All-in-one Dashboard with token market data, blockchain explorer, wallet, miner node manager and asset tracker. Now in 6 languages.',
      subContent8: 'Secure NKN-based e2e communication solution for massive IoT devices.',
      subContent9: 'Pub/Sub real-time messaging.',
      subContent10: 'Open marketplace for software services.',
      subContent11: 'Efficient nano payment channel.',
      subContent12: 'Official NKN Wallet for Mainnet.',
      subContent13: 'Blockchain explorer and node check.',
      subContent14: 'Miner portal, Node and Wallet tracker.',
      subContent15: 'More secure and convenient than SSH.',
      subContent16: 'High throughput file transfer.',
      subContent17: 'Improving packet reliability and latency.',
      subContent18: 'Decentralized PaaS for messaging, file transfer and streaming.',

      subContent1Link1: 'Presentation',
      subContent1Link2: 'Download Link',
      subContent2Link1: 'Try it',
      subContent3Link1: 'Link',
      subContent3Link2: 'GitHub',
      subContent3Link3: 'Project management',

      subContent5: 'Secure NKN-based e2e communication solution for massive IoT devices.',
      subContent5Link1: 'More information',
      subContent6: 'Decentralized chat based on NKN Pub/Sub.',
      subContent6Link1: 'More information',
      subContent6Link2: 'Gitlab',
      subContent7: 'New Kind of CDN using decentralized edge nodes.',
    },
    coreTech: {
      title: 'Core Technology',
      subtitle1: 'Decentralized Data Transmission Network (DDTN）',
      subContent1:
        'NKN maintains dynamic topology and routing based on Chord Distributed Hash Table for millions of nodes and clients, who can join and leave at any time. Unique NKN addresses are used to identify nodes and clients, providing an overlay on top of TCP/IP. Data can be transmitted from any client to any other client efficiently without centralized servers.',
      subtitle2: 'Proof of Relay (PoR)',
      subContent2:
        'NKN designed signature chain as a proof of relay for nodes along the route. This allows a level of secure data transmission that is not only verifiable but also impossible to tamper with or forge, and resistant to attacks.',
      subtitle3: 'MOCA: a highly scalable consensus algorithm',
      subContent3:
        'NKN designed a highly scalable consensus algorithm called Major Vote Cellular Automata (MOCA) based on Cellular Automata and Ising model, and has implemented it in our next generation blockchain and peer-to-peer network across millions of nodes.',
      subtitle4: 'Token/incentive distribution mechanism',
      subContent4:
        'NKN’s economic model will provide token rewards for participants who help relay traffic for other users. In addition, expected mining reward will also be proportional to the amount of data that participants help relay. These economic incentives will encourage the community to build and share the network.'
    },
    bounty: {
      title: 'Bounty Programs',
      subtitle1: '$ $ $',
      subContent1:
        'Calling for volunteers to port an open source messaging app to NKN. For the best app with >500 Daily Active Users, we pledge 100,000 NKN.',
      subContent1Link1: 'Link'
    },
    resources: {
      title: 'Developer resources',
      subtitle1: 'Github Code',
      subtitle2: 'Docs & Help',
      doc: 'Developer Doc',
      subtitle3: 'Tools',
      subtitle4: 'Client SDK by community'
    }
  },
  miner: {
    title: 'Miner Portal',
    miningIntro: {
      title: 'NKN Mining Intro',
      vtitle: 'Learn about NKN Mining in this 1 minute video'
    },
    started: {
      title: 'Get Started',
      subtitle1: 'Mining guide in English',
      subtitle2: 'Mining guide in Chinese',
      subtitle3: 'Mining guide in other language',
      sub1li1: 'A comprehensive guide with compiled links',
      sub1li2:
        'Setting up a NKN Miner in 5 Minutes and run it free for 2 months with DigitalOcean',
      sub1li3:
        'How to set up a NKN Miner on Windows 10 and run it as an automatic service',
      sub1li4: 'Make your own NKM (New Kind of Miner) out of a Raspberry pi',
      sub1li5: 'Script to set up a Raspberry Pi as a Plug & Play NKN miner',
      sub2li1: 'Chinese Mining Guides',
      sub2li2: 'Japanese Mining Guides (Digital Ocean cloud)',
      sub2li3: 'Japanese Mining Guides (Raspberry Pie)'
    },
    software: {
      title: 'Get NKN Mining software',
      subtitle1:
        'If you use own laptop or desktop PC, please download  GUI 1-click Miner application',
      subtitle2:
        'If you use cloud server or embedded devices, please follow our Mining FAQ',
      nknMiningFAQ: 'NKN Mining FAQ',
      githubBtn: 'Mining SW download',
      tutorial: 'Tutorial',
      pcMining: 'PC Mining',
      n1Mining: 'N1 Mining',
      raspberryPiMining: 'Raspberry pi mining',
      oneClickMining: '1-click for cloud platform Mining'
    },
    tools: {
      title: 'Mining Tools and Resources',
      // subtitle1: 'Official testnet.nkn.org',
      subtitle1: 'Mainnet explorer',
      subtitle2: 'Community built node and wallet tracker',
      subtitle3: 'Community built New kind of Dashboard'
    }
  },
  partner: {
    title: 'Partner Portal',
    topology: {
      nodeBC: 'Blockchain Projects',
      nodeCloud: 'Cloud Computing Platform',
      nodeTelco: 'Enterprise',
      nodeApp: 'Application Developer'
    },
    more: {
      title: 'Ecosystem attractions',
      subtitle1: 'Ultra Openness',
      subContent1:
        'Any nodes can connect to our fully open network from anywhere. NKN will always nurture network openness, true peer to peer connectivity and scalability.',
      subtitle2: 'Uberized Connectivity',
      subContent2:
        'Individuals earn token rewards by sharing idle connectivity and transmission capability. With this incentive model, NKN not only improves user experience , but also becomes more stable and attack resistant as more nodes join the network.',
      subtitle3: 'Community Co-Built Network',
      subContent3:
        'NKN incentivizes individuals and enterprises to deploy new equipment, upgrade network infrastructure, enhance network capacity, and improve network connectivity and reliability.'
    },
    list: {
      title: 'Partners',
      research: {
        title: 'Research Partner',
        crypticTitle: 'Cryptic Labs',
        crypticText: `NKN is collaborating with Cryptic labs to drive cryptology research behind NKN’s blockchain technology.  In addition, Professor Whitfield Diffie is a technical advisor to the team.`
      },
      telco: {
        title: 'Enterprise',
        tipTitle: 'TIP',
        tipText: `NKN has joined the Telecom Infrastructure Project (TIP) to bring NKN’s tokenized connectivity protocols and economy to projects such as Edge Compute, Open Cellular, and TIP Community Labs to help drive innovation and boost adoption of new telecom solutions.`,
        onfTitle: 'ONF',
        onfText: `NKN has joined the Open Network Foundation(ONF) to participate in projects such as ONOS and Stratum to enhance Software Defined Networks (SDN) as well as provide tokenized economic incentive to deploy open source infrastructure solutions.`,
        dpTitle: 'Datapace',
        dpText: `NKN has partnered with Datapace to offer Datapace’s decentralized data marketplace and sensor ecosystem on NKN’s global peer-to-peer network`
      },
      cloud: {
        title: 'Cloud Computing Platform',
        gcTitle: 'Google Cloud',
        gcText: `NKN software is available on Google Cloud Marketplace for easy setup and deployment on the Google Cloud Platform.`,
        awsTitle: 'AWS',
        awsText: `NKN software is available on AWS Marketplace for easy setup and deployment on AWS Cloud.`,
        dcTitle: 'Digital Ocean',
        dcText: `NKN is excited to be the first blockchain project available on the Digital Ocean Marketplace.  NKN software is available for easy 1-click deployment on the Digital Ocean platform.`
      },
      developer: {
        title: 'Application developer',
        pnTitle: 'Portal Network',
        pnText: `NKN is collaborating with Portal Network to develop a NKN Name Service (NNS) for the NKN Network.`,
        o3Title: 'O3 Labs',
        o3Text: `NKN is working with O3 Labs to bring NKN token to the O3 mobile wallet.`,
        w3iTitle: 'Web3infra alliance',
        w3iText: `Web3Infra Alliance intend to unify the decentralized ecosystem by integrating different Web3 components to create an open and unified environment`
      },
      blockchain: {
        title: 'Blockchain projects',
        IoTeXTitle: 'IoTeX',
        IoTeXText: `
        IoTeX is the auto-scalable and privacy-centric blockchain platform for the Internet of Things (IoT).  IoTeX is developing several in-house innovations to push the frontier of blockchain 3.0, including a blockchains-in-blockchain architecture for heterogeneous computing, Roll-DPoS consensus mechanism for high scalability, and lightweight privacy-preserving techniques.`,
        UUUTitle: 'UUU',
        UUUText: `
        U Network is the first quality content blockchain and the first global decentralized content publishing and valuation platform. U Network was designed to provide a prediction market on content value for the users in order to establish a reasonable pricing mechanism, to help users discover valuable content and information, and to tackle the incentive issue for quality content.`,
        dxcTitle: 'DxChain',
        dxcText: `
        DxChain is the world's first decentralized big data and machine learning network powered by a computing-centric blockchain.  As a public chain, DxChain aims to design a platform to solve computation of big data in a decentralized environment.  For simplicity, DxChain can also store and trade big data, so as to make data more valuable with the computation.`
      },
      equipment: {
        title: 'Network Equipment Vendors',
        nokiaTitle: 'Nokia',
        nokiaText:
          'NKN is part of Nokia’s Open Ecosystem and was recognized as an innovator as part of the Nokia Open Innovation Challenge 2018.  NKN has also partnered with Datapace, an incubator project from Nokia’s DIA (Digital Innovation Acceleration) organization to offer Datapace’s decentralized data marketplace and sensor ecosystem on NKN’s global peer-to-peer network.'
      },
      iQIYI: {
        title: "iQIYI",
        text: 'NKN signed commercial contract with iQIYI to provide edge computing service for video content delivery. iQIYI is an innovative market-leading online entertainment service in China.'
      },
      chinaMobile: {
        title: 'China Mobile',
        text: 'NKN has signed a collaboration agreement with a division of China Mobile in Southern China: covering key areas such as cloud computing, network, and blockchain. The first real use case will be content delivery over China Mobile’s edge data center.'
      },
      netnic: {
        title: 'NETNIC',
        text: 'NKN signed a commercial contract with NETNIC for New Kind of Content Delivery Service, nCDN. By working together with NKN, NETNIC can continue to improve its content delivery services for its clientele of more than 100,000 enterprise customers.'
      }
    }
  },
  news: {
    title: 'News',
    socialMedia: {
      title: 'Social Media Updates',
      newsList: {
        advisor: {
          title:
            'Founder and CEO Stephen Wolfram Joins NKN As Technical Advisor',
          time: 'Dec 18, 2018',
          desc:
            'NKN announces Dr. Stephen Wolfram, founder and CEO of Wolfram Research, has joined the NKN project as technical advisor. Wolfram will provide technical guidance and entrepreneurial mentorship to the NKN project.'
        },
        nokia: {
          title: 'NKN Finalist for Nokia Open Innovation Challenge 2018',
          time: 'Dec 12, 2018',
          desc:
            'NKN was chosen as one of the 6 finalists out of over 300 applicants in the Nokia Open Innovation Challenge 2018 and was invited to present at the awards ceremony on December 6th in Murray Hill, NJ, all expenses paid by Nokia.'
        },
        redemption: {
          title: 'NKN Bi-weekly Report December 4',
          time: 'December 17, 2018',
          desc: `• Early Redemption for NKN test tokens
          • NKN Finalist for Nokia Open Innovation Challenge 2018
          • AMA and video interview for Chinese speaking community`
        }
      }
    },
    video: {
      title: 'Video Updates'
    }
  },
  about: {
    titleText: `NKN was founded in January 2018 by a group of entrepreneurs and engineers with many years of building networking and blockchain technology in companies like Google, Nokia, QCOM, Baidu, and Onchain. The ideal driving this team is that blockchain provides both technical and economic innovations to disrupt the networking business.
    The team has two offices, in Silicon Valley, California and Beijing, China.`,
    map: {
      tag1: 'Silicon Valley Office',
      tag2: 'Beijing Office'
    },
    member: {
      title: 'Core team & Advisors',
      yanbo: {
        name: 'Yanbo Li',
        position1: 'Founder | Strategy & System Architecture',
        position2: 'Former Co-founder of Onchain',
        intro: `Open-source advocate, Linux Kernel network subsystem code contributor.
Profound experience in blockchain system architecture and development.
10+ years of P2P/Mesh network protocol development experience at Qualcomm, Nokia networks.`
      },
      bruce: {
        firstname: 'Zheng',
        lastname: `“Bruce” Li`,
        position1: 'Co-Founder',
        position2: 'Strategy & Operations',
        intro: `Founded multiple internal startup projects at Nokia & Google towards commercialization.
Expert on telecom innovation, specializing in strategy and business development.`
      },
      yilun: {
        name: `Yilun Zhang`,
        position1: 'Co-Founder',
        position2: 'Core Researcher & Developer',
        intro: `Ph.D in physics at University of California San Diego. B.S. in physics at Peking University.
Domain expert in Cellular Automata, Ising model and distributed information processing systems. Full stack engineer.`
      },
      allen: {
        name: `Allen Dixon`,
        position1: 'Business Development',
        position2: 'Business Compliance',
        intro: `Senior BD expert proficient at integrating tech and business to create new opportunities.
20+ years of Telecom experience. Led partnerships with Apple, Amazon, startups, and more.`
      },
      diffle: {
        name: 'Whitfield Diffie',
        honor1: 'Inventor of public key cryptography (Diffie-Hellman)',
        honor2: '2015 Turing Award winner',
        honorlist: {
          row1: 'Fellow of the Royal Society;',
          row2: 'Member, National Academy of Engineering;',
          row3:
            'Honorary doctorate from the Swiss Federal Institute of Technology;',
          row4: 'Fellow of the Marconi Foundation;',
          row5:
            'Doctor of Science (Honoris Causa) by Royal Holloway, University of London;',
          row6: 'IEEE Donald G. Fink Prize Paper Award in 1981;',
          row7: 'The Franklin Institute’s Louis E. Levy Medal in 1997;',
          row8:
            'Golden Jubilee Award for Technological Innovation from the IEEE Information Theory Society;',
          row9: 'IEEE Richard W. Hamming Medal in 2010.'
        }
      },
      wolfram: {
        name: 'Stephen Wolfram',
        honor1: 'Founder and CEO of Wolfram Research',
        honorlist: {
          row1: 'PhD in theoretical Physics, Caltech, 1979;',
          row2: 'Recipient, MacArthur Genius Award, 1981;',
          row3: 'Long-term member, Institute for Advanced Study, 1983-1986;',
          row4: 'Founder, Center for Complex Systems Research;',
          row5:
            'Adjunct Professor of Mathematics, Computer Science, Physics, University of Illinois Urbana- Champaign;',
          row6: 'Founder, Journal of Complex Systems;',
          row7: 'Fellow, American Association for the Advancement of Science;',
          row8: 'Bestselling author of A New Kind of Science;',
          row9:
            'Recipient, Speaker of the Event Award from SXSW Interactive for Making the Biggest Impact on the Digital Community, 2012;',
          row10: 'Inaugural Fellow, American Mathematical Society;',
          row11: 'Founding Trustee, Museum of Mathematics.'
        }
      }
    },
    roadmap: {
      title: 'Roadmap',
      testnetFlag: 'TESTNET',
      mainnetFlag: 'MAINNET',
      firefox: {
        time: 'June 16th, 2018',
        title: 'V0.1 "Firefox" release',
        desc:
          'First live testnet over global nodes with all core subsystems working together'
      },
      lemur: {
        time: 'August，2018',
        title: 'V0.3 "Lemur" release',
        desc: 'Optimizing scalability and efficiency, SDK alpha release'
      },
      koala: {
        time: 'October，2018',
        title: 'V0.5 “Koala” release',
        desc:
          'Enhancing attack resistance, larger scale testnet, SDK Beta release'
      },
      meerkat: {
        time: 'January，2019',
        title: 'V0.7 “Meerkat” release',
        desc:
          'Full featured testnet with complete implementation and performance, SDK v1.0 release'
      },
      beluga: {
        time: 'March，2019',
        title: 'V0.9 “Beluga” release',
        desc:
          'Further develop and improve NKN core system based on status of the TestNet'
      },
      narwhal: {
        time: 'June，2019',
        title: 'V1.0 “Narwhal” release',
        desc: 'Launch MainNet & NKN ecosystem'
      }
    },
    partnerTitle: 'Partners and Alliances',
    exchangeTitle: 'Exchanges',
    texture: {
      text1: 'Free the bits,',
      text2: 'rebuild the Internet we always wanted'
    }
  },
  nMobileDownload: {
    nMobile: 'nMobile',
    powered: 'Powered by NKN',
    description: 'nMobile is secure mobile chat that eliminates the possibility of security and privacy breaches by removing centralized servers entirely.',
    userBenefits: 'User Benefits',
    extraSecureChat: 'Extra Secure Chat',
    security:{
      title: 'Security & Privacy Focused',
      item1:{
        title: 'Data Storage',
        detail: 'Only on your device, never in cloud',
      },
      item2:{
        title: 'No Central Server',
        detail: 'eliminates cloud database breaches',
      },
      item3:{
        title: '100% Open Source',
        detail: 'transparent, auditable, trusted',
      },
      item4:{
        title: 'Private Key',
        detail: 'Only on your device, never in cloud',
      },
      item5:{
        title: 'end-to-end Encryption',
        detail: 'no data is accessible in transit',
      },
    },
    secureChatCompared: {
      title: 'Secure Chat Compared',
      detail: '<p>nMobile is more secure than popular chat apps like WhatsApp and Signal. </p><br> <p>nMobile is <a target="_blank" class="link" href="https://github.com/nknorg/nMobile">Open Sourced!</a> Nothing to hide, and cannot be evil.</p>',
    },
    mobileCryptoWallet: {
      title: 'Mobile Crypto Wallet',
      subContent1: 'Manage NKN token balance and payments on the go (mainnet and ERC-20)',
      subContent2: 'Swap between Mainnet and ERC-20 NKN tokens (in future)'
    },
    securePrivateChat: {
      title: 'Secure & Private Chat',
      subContent1: 'Direct, end-to-end encrypted messaging.  No message is stored in the cloud.',
      subContent2: 'Chat between nMobile and D-Chat users. D-Chat  plugin available on',
      and: 'and',
      browsers: 'browsers.',
      Chrome: 'Chrome',
      FireFox: 'FireFox'
    },
    secureRemoteAccess: {
      title: 'Secure Remote Access (Coming Soon)',
      subContent1: 'Manage remote devices such as IoT, Security Cameras, or remote servers using secure messaging, tunnel and nShell.',
      subContent2: 'Secure and direct transfer of large files'
    },
    learnMore: {
      title: 'Learn More',
      item1: {
        title: 'nMobile: The Trusted Chat'
      },
      item2: {
        title: 'Introducing nMobile - Extra Secure Chat'
      }
    },
    download: 'Download',
    wxtips: 'Click on the upper right corner and select open in browser',
    ScanToDownload: 'Scan to Download',
    DownloadFor: 'Download for',
    production: 'Production',
    beta: 'Beta'
  },
  nMobileProDownload: {
    nMobile: 'nMobile Pro',
    powered: 'Powered by NKN',
    description: 'nMobile Pro adds a series of commercial functions such as nCDN and nConnect on the basis of nMobile. Apart from secure and private communication, it also guarantees a whole bunch of daily conveniences offered by NKN.',
    userBenefits: 'User Benefits',
    extraSecureChat: 'nMobile Commercial',
    security:{
      title: 'Security & Privacy Focused',
      item1:{
        title: 'Data Storage',
        detail: 'Only on your device, never in cloud',
      },
      item2:{
        title: 'No Central Server',
        detail: 'eliminates cloud database breaches',
      },
      item3:{
        title: '100% Open Source',
        detail: 'transparent, auditable, trusted',
      },
      item4:{
        title: 'Private Key',
        detail: 'Only on your device, never in cloud',
      },
      item5:{
        title: 'end-to-end Encryption',
        detail: 'no data is accessible in transit',
      },
    },
    secureChatCompared: {
      title: 'Secure Chat Compared',
      detail: '<p>nMobile is more secure than popular chat apps like WhatsApp and Signal. </p><br> <p>nMobile is <a target="_blank" class="link" href="https://github.com/nknorg/nMobile">Open Sourced!</a> Nothing to hide, and cannot be evil.</p>',
    },
    mobileCryptoWallet: {
      title: 'Mobile Crypto Wallet',
      subContent1: 'Manage NKN token balance and payments on the go (mainnet and ERC-20)',
      subContent2: 'Swap between Mainnet and ERC-20 NKN tokens (in future)'
    },
    securePrivateChat: {
      title: 'Secure & Private Chat',
      subContent1: 'Direct, end-to-end encrypted messaging.  No message is stored in the cloud.',
      subContent2: 'Chat between nMobile and D-Chat users. D-Chat  plugin available on',
      and: 'and',
      browsers: 'browsers.',
      Chrome: 'Chrome',
      FireFox: 'FireFox'
    },
    secureRemoteAccess: {
      title: 'Secure Remote Access (Coming Soon)',
      subContent1: 'Manage remote devices such as IoT, Security Cameras, or remote servers using secure messaging, tunnel and nShell.',
      subContent2: 'Secure and direct transfer of large files'
    },
    learnMore: {
      title: 'Learn More',
      item1: {
        title: 'nMobile: The Trusted Chat'
      },
      item2: {
        title: 'Introducing nMobile - Extra Secure Chat'
      }
    },
    download: 'Download',
    wxtips: 'Click on the upper right corner and select open in browser',
    ScanToDownload: 'Scan to Download',
    DownloadFor: 'Download for',
    production: 'Production',
    beta: 'Beta'
  }
});



// WEBPACK FOOTER //
// ./src/i18n/en.js